import {
    AxiosHeaders,
    IRequestFetcherOptions
} from "src/common/razzle-platform-components/types"
import axios from 'src/common/razzle-platform-components/axios'
import {BASE_API_URL, PUBLIC_PRODUCT_API_END_POINT,TAGS_OF_PRODUCTS_API_END_POINT} from 'src/common/razzle-platform-product/configs'


export const fetchProduct = async (id: string, options: Pick<IRequestFetcherOptions, 'params'>, headers: AxiosHeaders={}) => {

    const params = options.params || {}

    const response = await axios.get(`${BASE_API_URL}${PUBLIC_PRODUCT_API_END_POINT}/${id}`, {params, headers})

    return { product: response.data }
}


// when we make several requests all at once we need the token to take the last request and cancel the others
const CancelToken = axios.CancelToken
let cancelFetchProductsRequest: any



export const fetchProducts = async (options: IRequestFetcherOptions={params: null, useUrlParams: true, usePagination: true, searchParams: null }, headers: AxiosHeaders={}) => {

    Boolean(cancelFetchProductsRequest) && cancelFetchProductsRequest()

    let params = {
        _page: '1',
        _per_page: '8',
    }

    if (options.useUrlParams) {
        params = { ...params, ...options.searchParams }
    }

    if (options.params) {
        params = {...params, ...options.params}
    }

    if (options.usePagination === false) {
        delete params._page
        delete params._per_page
    }

    const response = await axios.get(`${BASE_API_URL}${PUBLIC_PRODUCT_API_END_POINT}`, {
        params,
        headers,
        cancelToken: new CancelToken(function executor(c) {
            cancelFetchProductsRequest = c;
        }),
    })

    const count = parseInt(response.headers['x-total-count'], 10)
    const pagination = {
        count,
        page: parseInt(params._page || '1', 10),
        perPage: options.usePagination ? parseInt(params._per_page, 10) : count,
    }

    return { products: response.data, pagination }
}

export const fetchTagsOfProducts = async (options: Pick<IRequestFetcherOptions, 'params'>={params: null }, headers: AxiosHeaders={}) => {
    const params = options.params || {}
    const response = await axios.get(`${BASE_API_URL}${TAGS_OF_PRODUCTS_API_END_POINT}`, {
        params,
        headers,
    })
    
    return { tagsOfProducts: response.data }
}